import { Lock, ShieldCheck, BadgeCheck, RefreshCcw } from "lucide-react";

const SEALS = [
  { icon: Lock, label: "256-bit SSL encrypted" },
  { icon: ShieldCheck, label: "PCI-DSS compliant gateway" },
  { icon: BadgeCheck, label: "Server-verified payments" },
  { icon: RefreshCcw, label: "7-day refund policy" },
];

const METHODS = ["UPI", "Visa", "Mastercard", "RuPay", "Netbanking", "Wallets"];

/** Payment trust seals + accepted methods. No gateway brand name is exposed. */
export const TrustBadges = ({ className = "" }) => (
  <div data-testid="payment-trust-badges" className={`nv-card p-4 ${className}`}>
    <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
      {SEALS.map(({ icon: Icon, label }) => (
        <span key={label} className="inline-flex items-center gap-1.5 text-[11px] font-medium text-zinc-400">
          <Icon className="w-3.5 h-3.5 text-emerald-500 shrink-0" />
          {label}
        </span>
      ))}
    </div>
    <div className="mt-3 flex flex-wrap items-center gap-2">
      <span className="text-[10px] font-num uppercase tracking-[0.18em] text-zinc-500">We accept</span>
      {METHODS.map((m) => (
        <span
          key={m}
          data-testid={`pay-method-${m.toLowerCase()}`}
          className="rounded-md border border-zinc-800 px-2 py-0.5 text-[10px] font-num tracking-wide text-zinc-400"
        >
          {m}
        </span>
      ))}
    </div>
    <p className="mt-3 text-[11px] leading-relaxed text-zinc-500">
      Payments are processed by an RBI-authorised payment aggregator. Card details never touch our servers, and every
      transaction is confirmed server-side before your plan unlocks.
    </p>
  </div>
);

export default TrustBadges;
